/* eslint-disable */

import $ from 'jquery';
import loadingLayer from '../util/loadingLayer';
import formMessages from '../util/formMessages';
import stateAndCountry from '../util/stateAndCountry';

export default {
    init() {
        formMessages().useCaptcha();
        const $form = $('#member-account-details');

        stateAndCountry($form);
        formMessages($form).validate();

        $form.on('submit', function(event) {
            event.stopImmediatePropagation();
            event.preventDefault();

            loadingLayer.showLoading();
            formMessages($form).init();

            const url = $form.attr('action-ajax') || $form.attr('action');
            const method = $form.attr('method');

            const formData = $form.find("select:visible,input[type=hidden],:input:visible,textarea:visible").serializeArray();
            const data = {};

            for (var i in formData) {
                data[formData[i].name] = formData[i].value;

                $('#' + formData[i].name, $form).removeClass('is-invalid');
                $('#' + formData[i].name + ' ~ .invalid-feedback', $form).text('');
            }

            $.ajax({
                url,
                method,
                data: {
                    ...data,
                    nonce: window.meta_object.nonce,
                    captcha_token: window.meta_object.captcha_token,
                    action: 'member-account-details',
                },
                dataType: 'json',
                complete: function (data) {
                    loadingLayer.hideLoading();
                },
                success: function (data) {
                    if (!data) return;
                    
                    formMessages($form, data).run();
                },
                error: function(err) {
                    console.log('error', err);
                }
            });
        });

        formMessages('#member-account-password').validate();
        $('#member-account-password').on('submit', function(event) {
            event.stopImmediatePropagation();
            event.preventDefault();

            const $form = $(this);
            loadingLayer.showLoading();
            formMessages($form).init();

            const url = $form.attr('action-ajax') || $form.attr('action');
            const method = $form.attr('method');

            const formData = $form.find("select:visible,input[type=hidden],:input:visible,textarea:visible").serializeArray();
            const data = {};

            for (var i in formData) {
                data[formData[i].name] = formData[i].value;

                $('#' + formData[i].name, $form).removeClass('is-invalid');
                $('#' + formData[i].name + ' ~ .invalid-feedback', $form).text('');
            }

            $.ajax({
                url,
                method,
                data: {
                    ...data,
                    nonce: window.meta_object.nonce,
                    captcha_token: window.meta_object.captcha_token,
                    action: 'member-account-password',
                },
                dataType: 'json',
                complete: function (data) {
                    loadingLayer.hideLoading();
                },
                success: function (data) {
                    if (!data) return;
                    formMessages($form, data).run();
                },
                error: function(err) {
                    console.log('error', err);
                }
            });
        });
    },
    finalize() {

    },
  };
  


// WEBPACK FOOTER //
// ./scripts/routes/memberAccount.js